import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "title-color-black my-5" }, "IRB Admin", -1)
const _hoisted_2 = { class: "mb-5 mb-xl-8 card" }
const _hoisted_3 = { class: "card-body py-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "title-color-brown" }, "Users", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fs-8 subtitle-color-gray" }, "Pending Users", -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  class: "col-xs-12",
  style: {"text-align":"right"}
}
const _hoisted_8 = {
  class: "btn btn-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_9 = { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_user_approve",
  id: "fakeModalId",
  class: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_DropdownUsersFilter = _resolveComponent("DropdownUsersFilter")!
  const _component_AplicationTableAction = _resolveComponent("AplicationTableAction")!
  const _component_KtUserApproveModal = _resolveComponent("KtUserApproveModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen031.svg" })
              ]),
              _createTextVNode(" Filter ")
            ]),
            _createVNode(_component_DropdownUsersFilter, { tableCallFunction: _ctx.tableCallFunction }, null, 8, ["tableCallFunction"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_AplicationTableAction, {
            list: _ctx.currentPendingUsers?.data,
            functionToCall: _ctx.editUser,
            pagination: _ctx.currentPendingUsers?.filters,
            tableColumns: _ctx.tableColumns,
            tableCallFunction: _ctx.tableCallFunction,
            hiddeSearchBar: true
          }, null, 8, ["list", "functionToCall", "pagination", "tableColumns", "tableCallFunction"])
        ])
      ])
    ]),
    _hoisted_11,
    _createVNode(_component_KtUserApproveModal)
  ], 64))
}